import { create } from 'zustand';
import { 
  getMWCTransactions,
  createPenerimaanInfak,
  createPenerimaanDanaAmil,
  createPenerimaanZakat,
  createPenyaluran,
  createBebanPengelolaan,
  updateMWCTransaction,
  deleteMWCTransaction
} from '../services/mwcService';

const useMWCTransactionStore = create((set, get) => ({
  transactions: [],
  loading: false,
  error: null,

  fetchTransactions: async () => {
    set({ loading: true, error: null });
    try {
      const data = await getMWCTransactions();
      set({ transactions: data, loading: false });
    } catch (error) {
      set({ error: error, loading: false });
    }
  },

  addPenerimaanInfak: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await createPenerimaanInfak(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },

  addPenerimaanDanaAmil: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await createPenerimaanDanaAmil(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },

  addPenerimaanZakat: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await createPenerimaanZakat(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },

  addPenyaluran: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await createPenyaluran(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },

  addBebanPengelolaan: async (transactionData) => {
    set({ loading: true, error: null });
    try {
      await createBebanPengelolaan(transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },

  updateTransaction: async (id, transactionData) => {
    set({ loading: true, error: null });
    try {
      await updateMWCTransaction(id, transactionData);
      await get().fetchTransactions(); // Refetch all transactions
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },

  removeTransaction: async (id) => {
    set({ loading: true, error: null });
    try {
      await deleteMWCTransaction(id);
      set((state) => ({
        transactions: state.transactions.filter((t) => t.id !== id),
        loading: false,
      }));
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },
}));

export default useMWCTransactionStore;